// @ts-strict-ignore
import { useTranslation } from "react-i18next";
import { getGraphLayout } from "../../../features/graph/state/graphLegacy";
import { SidebarItemProject } from "./SidebarItem";
import { getCurrentProject } from "../../../features/projects/state/projectsSlice";
import canSaveProject from "../../../features/graph/util/canSaveProject";
import { useNavigate, useLocation } from "react-router-dom";
import { VrStudioIcon } from "src/assets/VrStudioIcon";
import { useAppDispatch, useAppSelector } from "src/common/state/hooks";
import { openStandardModal } from "src/common/state/slice/modal/modalSlice";
import DeepLinkModal from "src/pages/Projects/DeepLinkModal";

const ProjectSidebar = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const hiddenSceneNodes = useAppSelector(getGraphLayout)[3];
  const currentProject = useAppSelector(getCurrentProject);
  const canSave = canSaveProject(currentProject);
  const location = useLocation();
  const path = location.pathname.split("/");
  const maxUnlinkedScenes = 15;

  const onMakeTemplate = () => {
    if (!currentProject.is_template) {
      navigate(`/courses/${path[2]}/template/${path[4]}`);
    } else {
      navigate(`/templates/${path[2]}/new`);
    }
  };

  const getTooltipText = () => {
    if (!canSave.canSave) {
      return canSave.reason ? t(canSave.reason) : t("tooltip.sceneMustHaveNameAndMedia");
    }

    if (hiddenSceneNodes.length >= maxUnlinkedScenes) {
      return t("pages.project.tooMuchUnlinkedScene");
    }

    return "";
  };

  return (
    <div className="bg-blue-500 rounded-md absolute top-1/3 px-2 py-3 max-w-min block space-y-2 z-10 w-1/2">
      {((currentProject.is_template === true &&
        currentProject.project_tags[0].slug === "custom-templates") ||
        currentProject.is_template === false) && (
        <div className="onboardingHowToAddScene-step-1">
          <SidebarItemProject
            title={t("sidebar.createScene")}
            icon="VideoCameraIcon"
            routeTo="create/scene"
            disabled={hiddenSceneNodes.length >= maxUnlinkedScenes || !canSave.canSave}
            tooltipText={getTooltipText()}
          />
        </div>
      )}
      {((currentProject.is_template === true &&
        currentProject.project_tags[0].slug === "custom-templates") ||
        currentProject.is_template === false) && (
        <div className="onboardingHowToAddScene-step-4">
          <SidebarItemProject
            title={t("sidebar.sound")}
            icon="MusicNoteIcon"
            routeTo="background-music/edit"
          />
        </div>
      )}
      {currentProject.is_template === true &&
        currentProject.project_tags[0].slug !== "custom-templates" && (
          <div className="onboardingHowToAddScene-step-4">
            <SidebarItemProject
              title={t("sidebar.sound")}
              icon="MusicNoteIcon"
              routeTo="background-music/view"
            />
          </div>
        )}

      <SidebarItemProject
        title={t("general.makeTemplate")}
        icon="SaveAsIcon"
        routeTo=""
        onClick={onMakeTemplate}
        tooltipText={t("tooltip.faitTemplate")}
      />

      <SidebarItemProject
        title={t("general.configureInteractions")}
        customIcon={
          <span className="pointer-events-none !opacity-100">
            <VrStudioIcon height={52} width={52} />
          </span>
        }
        routeTo=""
        onClick={() => dispatch(openStandardModal("modalDeepLink"))}
        // tooltipText={t("pages.project.edit.gotoStudioNoob")}
      />
      <DeepLinkModal />
    </div>
  );
};

export default ProjectSidebar;
